module.exports = __webpack_public_path__ + "static/media/color-map.7cb2f3f0.svg";